import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div>
          <h2 style={{ whiteSpace: 'pre-wrap', color: 'white', padding: '20px' }}>
            Something went wrong.
          </h2>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
